











































import Vue from "vue";
import Component from "vue-class-component";

import { Prop } from "vue-property-decorator";
import { Note } from "@/store/content";

import Avatar from "../Common/Avatar.vue";
import ReplyDetails from "./Details.vue";
import ReplyActions from "./Actions.vue";

import Content from "../Common/Content.vue";
import { Action } from "vuex-class";
const Edit = () => import("../Common/Edit.vue");

const namespace: string = "reply";

@Component({
  components: {
    Avatar,
    ReplyDetails,
    ReplyActions,
    Content,
    Edit
  }
})
export default class Main extends Vue {
  @Prop() reply!: Note;

  @Action("update", { namespace })
  private updateReplyVuex!: Function;

  private editing: boolean = false;

  private actionProps: object = {
    kekGiven: this.reply.liked,
    keks: this.reply.likes.length
  };

  private async updateReply(updatedContent: string) {
    const isSuccessful: boolean = await this.updateReplyVuex({
      content: updatedContent,
      replyPublicId: this.reply.public_id
    });

    // If update was successful (true).
    if (isSuccessful) {
      this.editing = false;

      this.reply.content = updatedContent;
      this.reply.edited = true;
    }
  }
}
